import Brightness4 from '@mui/icons-material/Brightness4'
import Brightness7 from '@mui/icons-material/Brightness7'
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, useColorScheme } from '@mui/material'
import { useCallback } from 'react'

export function DarkModeToggler({ sidebarOpen }: { sidebarOpen: boolean }) {
  const { mode, setMode } = useColorScheme()

  const onToggleMode = useCallback(() => {
    setMode(mode === 'dark' ? 'light' : 'dark')
  }, [mode, setMode])

  const text = mode === 'dark' ? 'Enable light mode' : 'Enable dark mode'

  return (
    <Tooltip arrow placement="right" title={sidebarOpen ? '' : text}>
      <ListItem
        data-testid="dark-mode-toggler"
        disablePadding
        onClick={onToggleMode}
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-end',
          padding: 0,
        }}
      >
        <ListItemButton
          sx={{
            justifyContent: sidebarOpen ? 'initial' : 'center',
            minHeight: 48,
            padding: 0,
          }}
        >
          <ListItemIcon
            sx={{
              justifyContent: 'center',
              minWidth: 0,
              px: 1,
            }}
          >
            {mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
          </ListItemIcon>
          <ListItemText primary={text} sx={{ opacity: sidebarOpen ? 1 : 0 }} />
        </ListItemButton>
      </ListItem>
    </Tooltip>
  )
}
